export default "__VITE_ASSET__BMcHUw6h__"